const PuffTheMagicDragon = [
	'[CHORUS]',
	'Puff, the magic dragon lived by the sea',
	'And frolicked in the autumn mist in a land called Honah Lee',
	'',
	'[VERSE 1]',
	'Little Jackie Paper loved that rascal Puff,',
	'And brought him strings and sealing wax and other fancy stuff. Oh',
	'',
	'[CHORUS]',
	'Puff, the magic dragon lived by the sea',
	'And frolicked in the autumn mist in a land called Honah Lee',
	'[CHORUS]',
	'Puff, the magic dragon lived by the sea',
	'And frolicked in the autumn mist in a land called Honah Lee',
	'',
	'[VERSE 2]',
	'Together they would travel on a boat with billowed sail',
	"Jackie kept a lookout perched on Puff's gigantic tail,",
	"Noble kings and princes would bow whene'er they came,",
	'Pirate ships would lower their flags when Puff roared out his name. Oh!',
	'',
	'[CHORUS]',
	'Puff, the magic dragon lived by the sea',
	'And frolicked in the autumn mist in a land called Honah Lee',
	'[CHORUS]',
	'Puff, the magic dragon lived by the sea',
	'And frolicked in the autumn mist in a land called Honah Lee',
	'',
	'[VERSE 3]',
	'A dragon lives forever but not so little boys',
	"Painted wings and giants' rings make way for other toys.",
	'One grey night it happened, Jackie Paper came no more',
	'And Puff that mighty dragon, he ceased his fearless roar.',
	'',
	'[VERSE 4]',
	'His head was bent in sorrow, green scales fell like rain,',
	'Puff no longer went to play along the cherry lane.',
	'Without his lifelong friend, Puff could not be brave,',
	'So Puff that mighty dragon sadly slipped into his cave. Oh!',
	'',
	'[CHORUS]',
	'Puff, the magic dragon lived by the sea',
	'And frolicked in the autumn mist in a land called Honah Lee',
	'',
	'[CHORUS]',
	'Puff, the magic dragon lived by the sea',
	'And frolicked in the autumn mist in a land called Honah Lee',
];

export default PuffTheMagicDragon;
